import type { DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns'

export type FilterFieldConfig = {
  id: string
  label: string
  type: 'text' | 'multiselect'
  accessor: (doc: DocumentTableRow) => string | null
}

export const FILTER_FIELDS: FilterFieldConfig[] = [
  { id: 'title', label: 'File Name', type: 'text', accessor: (d) => d.title },
  {
    id: 'documentTitle',
    label: 'Document Title',
    type: 'text',
    accessor: (d) => d.documentTitle,
  },
  { id: 'system', label: 'System', type: 'text', accessor: (d) => d.system },
  {
    id: 'vendor',
    label: 'Vendor',
    type: 'multiselect',
    accessor: (d) => d.vendor,
  },
  {
    id: 'docType',
    label: 'Type',
    type: 'multiselect',
    accessor: (d) => d.docType,
  },
  {
    id: 'drawing',
    label: 'Drawing Number',
    type: 'text',
    accessor: (d) => d.drawing,
  },
]

export type CardFilterValues = Record<string, string | string[]>
